import { ShopByContainerProps } from '../../../components/ShopByContainer/ShopByContainer';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
import transformNavigationMenu from '../navigation-menu-transformer/navigationMenuTransformer';

const transformShopByContainer = (data: CMSTransformerDataType): ShopByContainerProps => {
  const transformedNavigationMenu = transformNavigationMenu(data);
  return {
    ...transformedNavigationMenu,
    componentType: ComponentType.shop_by_container,
    hideNavigation: data.hideNavigation,
  };
};

export default transformShopByContainer;
